export default function DateFilter(value, format = 'YYYY-MM-DD') {
    if (value) {
        return moment(value).format(format);
    }
}
